import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Eyebrow, SectionHeading } from "../common/Type";
import { Reveal } from "../common/Reveal";
import { faqs as defaultFaqs } from "../../lib/content";

export default function FaqSection({ faqs = defaultFaqs, heading = "Questions, answered directly." }) {
  return (
    <section className="relative py-24 md:py-32" data-testid="section-faq">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <Eyebrow className="mb-5">FAQ</Eyebrow>
          <SectionHeading>{heading}</SectionHeading>
        </div>

        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-kv-steel/20" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-display text-base md:text-lg text-kv-off hover:no-underline py-6 text-left">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-sm md:text-base text-kv-grey leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
